
import { Placement } from '@post-office/placements-frontend/townsquare-screen-space-flags';
export default Placement;
